<div class="card" [ngClass]="class">
    <div class="card-body py-2">
        <div class="row">
            @for (card of items; track card; let last = $last) {
                <div class="col-md-4 border-end" [class.border-end-0]="last">
                    <div class="d-flex align-items-center p-2">
                        <div class="d-flex align-items-center justify-content-center flex-shrink-0 me-3 rounded-circle"
                             [ngClass]="card.bg"
                             style="width:48px;height:48px;"
                        >
                            <i [class]="card.icon + ' fs-5 ' + card.color"></i>
                        </div>
                        <div>
                            <div class="fs-4 mb-0">
                                @if (card.currency) {
                                    {{ card.value | currency }}
                                } @else {
                                    {{ card.value | number:'1.0-2' }}
                                }
                            </div>
                            <small class="fw-bold">{{ card.label }}
                                @if (card.subLabel) {
                                    <span class="text-muted fw-normal">{{ card.subLabel }}</span>
                                }
                            </small>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
